<template>
	<div class="prose max-w-none bg-white antialiased">
		<OrderHeader />

		<div class="pb-8 pt-2 sm:container xl:px-6">
			<TwoColumns
				v-if="showColumns"
				:has-padding-first-column="false"
				:has-padding-second-column="false"
				first-column-width="w-full lg:w-2/5 xl:w-1/2"
				second-column-width="w-full lg:w-3/5 xl:w-1/2"
				first-column-class=""
				second-column-class="p-6 lg:px-0"
				column-gap="gap-4 md:gap-8"
			>
				<template #first>
					<OrderSteps class="px-4 lg:hidden lg:px-0" />

					<div class="px-4 lg:h-full lg:px-0">
						<SummaryOverview />
					</div>
				</template>
				<template #second>
					<OrderSteps class="hidden lg:block" />

					<slot />
				</template>
			</TwoColumns>
			<template v-else>
				<slot />
			</template>
		</div>

		<DashboardFooter />
	</div>
</template>

<script setup>
import DashboardFooter from '@/components/footers/DashboardFooter.vue'
import OrderHeader from '@/components/headers/OrderHeader.vue'
import OrderSteps from '@/components/order-checkout/OrderSteps.vue'
import SummaryOverview from '@/components/order-checkout/SummaryOverview.vue'
import TwoColumns from '@/components/sections/TwoColumns.vue'
/*******
 * Layout settings
 *
 * To disable the footer per page, use definePageMeta({layoutSettings: {showFooter: false}})
 * To disable the menu per page, use definePageMeta({layoutSettings: {showMenu: false}})
 *
 *******/
const route = useRoute()
const showColumns = computed(
	() => route.meta.layoutSettings?.showColumns ?? true
)

// we need to call this here to trigger the hydration of the carbar-Au-Auth-Store within the initial setups, otherwise
// we get an "onUnmounted" warning from pinia's persisted state. See DE-5187
isLoggedIn()
checkAuthLoginVersion()

onBeforeMount(() => {
	useRecaptcha()
})
</script>
